'use client';

import { Info } from 'lucide-react';
import mergeClasses from 'shared/lib/utils';
import { cva, type VariantProps } from 'class-variance-authority';
const linkVariants = cva('underline transition-colors duration-200 ease-in hover:text-foreground', {
  variants: {
    variant: {
      default: 'text-link',
      'no-highlight': 'text-foreground'
    }
  },
  defaultVariants: {
    variant: 'default'
  }
});
export interface LinkProps extends React.AnchorHTMLAttributes<HTMLAnchorElement>, VariantProps<typeof linkVariants> {
  docs?: boolean;
  className?: string;
  children?: string | React.ReactNode;
}
export function Link({
  docs = false,
  className,
  children,
  variant,
  ...props
}: LinkProps) {
  return <a className={mergeClasses(linkVariants({
    variant
  }), className)} href={props.href} target="_blank" rel="noopener noreferrer" {...props} data-sentry-component="Link" data-sentry-source-file="link.tsx">
      <div className="flex w-full items-center gap-2">
        {docs && <Info className="size-4 shrink-0" />}
        {typeof children === 'string' ? <span className="text-body2">{children}</span> : children}
      </div>
    </a>;
}